import { VacuumIcon } from './VacuumIcon';

/**
 * author: Google
 * id 280D39D7-C3B6-4C48-827F-D944B4773B0C
 * name vacuum
 * version: 6.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/vacuum.svg
 * tags
 * - Home Automation 
 */
export const VacuumCleanerIcon = VacuumIcon;
export default VacuumCleanerIcon